import { render } from "./SpecialsHeader.vue?vue&type=template&id=11ade143&scoped=true"
import script from "./SpecialsHeader.vue?vue&type=script&lang=js"
export * from "./SpecialsHeader.vue?vue&type=script&lang=js"

import "./SpecialsHeader.vue?vue&type=style&index=0&id=11ade143&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-11ade143"

export default script